import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'common/components/form/inputs/Select';

import { useActions } from 'utils/hooks';
import * as listActions from 'store/lists/actions';

const LogTypesSelector = ({ filter, value, onChange, label, placeholder }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const logTypes = useSelector(state => state.lists['logs-types']);

  useEffect(() => {
    if (!logTypes.options.length) fetchListOptions('logs-types');
  }, []);

  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.type}
      getOptionLabel={option => option.type}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={logTypes.options}
      isMulti={true}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? selected : ''
        })
      }
      isClearable
    />
  );
};

export default LogTypesSelector;
